import React, { Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router'
import { ROUTES } from '../../utils/routes'
import { useUser } from '../../utils'
import { Role } from 'common/api/v1/types'
import { ConfirmDialogProvider } from '../common/ConfirmDialog'
import { GlobalSearchProvider } from '../common/GlobalSearch/GlobalSearchProvider'
import { ContentDialogProvider } from '../common/ContentDialog'
import { mixpanel, usePageTracking } from '../../mixpanel'
import { Loading } from 'common-ui/components/Loading'

const EventManagerContainer = React.lazy(() => import('./EventManagerContainer'))
const NetworkManagerContainer = React.lazy(() => import('./NetworkManagerContainer'))
const StreamManagerContainer = React.lazy(() => import('./StreamManagerContainer'))

const LoggedIn = () => {
  const user = useUser()
  mixpanel.addUserInfo(user)
  usePageTracking()

  return (
    <ConfirmDialogProvider>
      <ContentDialogProvider>
        <GlobalSearchProvider>
          <Suspense fallback={<Loading fullScreen />}>
            <Routes>
              <Route path={`${ROUTES.stream}/*`} element={<StreamManagerContainer />} />
              <Route path={`${ROUTES.events}/*`} element={<EventManagerContainer />} />
              <Route
                path="/*"
                element={
                  user.role === Role.basic ? <Navigate to={ROUTES.stream} replace /> : <NetworkManagerContainer />
                }
              />
            </Routes>
          </Suspense>
        </GlobalSearchProvider>
      </ContentDialogProvider>
    </ConfirmDialogProvider>
  )
}

export default LoggedIn
